import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./Sagas/rootSaga";
import rootReducer from "./Redux/Reducers/root.reducer";
import { composeWithDevTools } from '@redux-devtools/extension';
import Landing from "./Pages/Landing/Landing";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free";

import "./index.css";

const sagaMiddleware = createSagaMiddleware();
const stripePublishable = loadStripe(`pk_test_51JJomHHgS6AIJsGaqh56ICyd3HNxfNU3h38p6Dfd6gxLFBmG2ZPKe5zVc34OaBUUNoFdNMZSla1VjvDbBNCMFhx200v3UAuUzs`)

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <Elements stripe={stripePublishable}>
      <Router>
        <Landing />
      </Router>
    </Elements>
  </Provider>,
  document.getElementById("root")
);
